import type { ReactNode } from "react";

export function SectionHeading({
  eyebrow,
  title,
  body,
  action,
  align = "left",
}: {
  eyebrow: string;
  title: string;
  body?: string;
  action?: ReactNode;
  align?: "left" | "center";
}) {
  return (
    <div className={`section-heading section-heading-${align}`}>
      <div>
        <span className="eyebrow">{eyebrow}</span>
        <h2>{title}</h2>
        {body && <p>{body}</p>}
      </div>
      {action}
    </div>
  );
}
